function randomizeBlocks(listTrials,listBlocks)
{
  var newOrder = new Array();
  noTrials = listBlocks.length;
  var listLevels = new Array();
  var listBlocksSplit = new Array();
  var listBlocksConcat = new Array();
  var listBlocksCurrentLevel = new Array();

  //determine number of levels defined
  for (var i = 0; i < noTrials; i++)
  {
    newOrder[i] = i;
    listBlocks[i] = listBlocks[i].replace('na', '0');//replace na with 0
    listBlocksSplit[i] = listBlocks[i].split(" ");
    listLevels[i] = listBlocksSplit[i].length;
    listBlocksConcat[i] = listBlocks[i].replace(' ', '_');//replace na with 0
  }
  nLevels = Math.max.apply(null, listLevels);

  //enforce that all trials have the same number of levels
  for (var i = 0; i < noTrials; i++)
  {
    while (listBlocksSplit[i].length < nLevels)
    {
    listBlocksSplit[i].push('0');
    listBlocksConcat[i] = listBlocksConcat[i].concat('_0');
    }
  }

  while (0 !== nLevels) //do while there are levels left
  {
    newOrderThisLevel = [];
    for (var i = 0; i < noTrials; i++)
    {
      if (listBlocksConcat[i].indexOf("_")>-1) //when there are at least two levels left
      {
        listBlocksCurrentLevel[i] = listBlocksConcat[i].substring(listBlocksConcat[i].lastIndexOf("_")+1);
        listBlocksConcat[i] = listBlocksConcat[i].substring(0,listBlocksConcat[i].lastIndexOf("_"));
      }
      else //only top level left
      {
        listBlocksCurrentLevel[i] = listBlocksConcat[i];
        listBlocksConcat[i] = "0";
      }
    }

  var flagsGroupStart = new Array();
  var flagsGroupEnd = new Array();
  var flagsGroup = new Array();
  var flagsBlockStart = new Array();
  var flagsBlockEnd = new Array();
  var flagsBlock = new Array();

  ///// first identify the groups
  flagsGroupStart.push(0);
  for (var i = 0; i < noTrials; i++)
  {
    //for all trials except last
    if (i != noTrials-1)
    {
      if (listBlocksCurrentLevel[i]*listBlocksCurrentLevel[i+1]=='0')
      {
        flagsGroupStart.push(i+1);
        flagsGroupEnd.push(i);
      }
      else if (listBlocksConcat[i]!=listBlocksConcat[i+1])
        {
            flagsGroupStart.push(i+1);
            flagsGroupEnd.push(i);
        }
    }
    //in case last trial should be randomised
    if (i == noTrials-1){flagsGroupEnd.push(i);}
  }


  for(var i=0;i<flagsGroupStart.length;++i)
  {
  flagsGroup[2*i]=flagsGroupStart[i];
  flagsGroup[2*i+1]=flagsGroupEnd[i];
  }
  nGroups = flagsGroupStart.length;

  ////// take group by group
  for(var i=0;i<nGroups;++i)
  {
    if (flagsGroupStart[i]==flagsGroupEnd[i])//for the one trial groups
    {
      newOrderThisLevel.push(flagsGroupStart[i]);
    }
    else
    {
      a = listBlocksCurrentLevel.slice(flagsGroupStart[i],flagsGroupEnd[i]+1);

      var flagStartBlock = [];
      var flagEndBlock = [];
      flagStartBlock.push(flagsGroupStart[i]);
      for(var l=0;l<a.length-1;++l)
      {
        if (a[l]!=a[l+1])
        {
          flagEndBlock.push([flagsGroupStart[i]+l]);
          flagStartBlock.push(flagsGroupStart[i]+l+1);
        }
      }
      flagEndBlock.push(flagsGroupEnd[i]);

      nBlocks = flagStartBlock.length;
      orderBlocks = randperm(nBlocks);

      for(var k=0;k<a.length;++k)
      {
        for (var x = flagStartBlock[orderBlocks[k]]; x <= flagEndBlock[orderBlocks[k]]; x++)
        {
          newOrderThisLevel.push(x);
        }
      }

    }//end groups with more than one trial

  }//end group by group

  tempOrder = [];
  for (var i = 0; i < noTrials; i++)
  {
    tempOrder[i] = newOrder[newOrderThisLevel[i]];
  }
  newOrder = tempOrder;

nLevels -= 1;

}//end while

  tempList = [];
  for (var i = 0; i < noTrials; i++)
  {
    tempList[i] = listTrials[newOrder[i]];
  }
  afterListTrials = tempList;

  return afterListTrials;

}

function randomizeWithinBlocks(listTrials,listRandom,listBlocks,listTrialTimerLabels)
{
//determine which files can be randomised (lowest level); randomBlock==randomBlock (in totalitate, for all levels); randomise them; get new order and work with it

///randomise trials at the lowest level
noTrials = listRandom.length;
var flagsStart = new Array();
var flagsEnd = new Array();
var flags = new Array();
for (var i = 0; i < noTrials; i++)
{
  //in case first trial should be randomised
  if (i == 0 && listRandom[i] != "na"){flagsStart.push(i);}
  //for all trials except last
  if (i != noTrials-1)
  {
    if (listRandom[i]!=listRandom[i+1])
    {
      if (listRandom[i]=="na")
      {
        flagsStart.push(i+1);
      }
      else if (listRandom[i+1]=="na")
      {
        flagsEnd.push(i);
      }
      else
      {
        flagsStart.push(i+1);
        flagsEnd.push(i);
      }
    }
    else if (listRandom[i]!="na" && (listBlocks[i]!=listBlocks[i+1] || listTrialTimerLabels[i] != listTrialTimerLabels[i+1]))
    {
      flagsStart.push(i+1);
      flagsEnd.push(i);
    }
  }
  //in case last trial should be randomised
  if (i == noTrials-1 && listRandom[i] != "na"){flagsEnd.push(i);}
}
for(var i=0;i<flagsStart.length;++i) {
  flags[2*i]=flagsStart[i];
  flags[2*i+1]=flagsEnd[i];
}

if (flags) {newList = randpermAB(noTrials,flags);}

  tempList = [];
  for (var i = 0; i < noTrials; i++)
  {
    tempList[i] = listTrials[newList[i]];
  }
  afterListTrials = tempList;

  return afterListTrials;

}

//sync call to random.org to get a sequence between min and max inclusive
function getRandomSequence(min, max) {
  var URL = 'https://www.random.org/sequences/?min=' + min + '&max=' + max + '&col=1&format=plain&rnd=new';
  var randomSeq = [];

  try {
      var xhr = new XMLHttpRequest();
  } catch (e) {
  } finally {
      xhr.ontimeout = function () { randomPoolInitialized = true };
      xhr.onload = function () {
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  randomSeq = xhr.responseText.trim().split(/\W+/g);
              }
          }
      };

      xhr.open("GET", URL, false);
      xhr.send(null);
  }

  return randomSeq;
}


//sync call to random.org to get a number between min and max inclusive
//fallback to standard random
function getRandomInteger(min, max) {

  if (!window.advanced_random) {
    return getJsRandomInt(min, max);
  }

  var URL = 'https://www.random.org/integers/?num=1&min=' + min + '&max=' + max + '&col=1&base=10&format=plain&rnd=new';
  // console.log(URL);
  var randomInteger = min - 1;

  try {
      var xhr = new XMLHttpRequest();
  } catch (e) {}
  finally {
      xhr.onload = function () {
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  randomInteger = parseInt(xhr.responseText.trim());
                  !isNaN(randomInteger) && console.log('random from random.org')
              }
          }
      };

      try {
        xhr.open("GET", URL, false);
        xhr.send(null);
      }
      catch(e) {}
      finally {
        if (isNaN(randomInteger) || randomInteger < min) {
          randomInteger = getJsRandomInt(min, max);
          console.log('random from JavaScript')
        }
      }
  }

  return randomInteger;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 * Using Math.round() will give you a non-uniform distribution!
 */
 // https://stackoverflow.com/questions/1527803/generating-random-whole-numbers-in-javascript-in-a-specific-range
function getJsRandomInt(min, max) {
    min = parseInt(min);
    max = parseInt(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}